export default {
  getOperation : (state) => { return state.operation; },
  getStatus : (state) => { return state.isBusy; },
}
